import styled from 'styled-components';
import tinycolor from 'tinycolor2';
import { getAutomatedStyleProp } from '../../providers/ComponentsThemeProvider';
const getOutlineColor = ({ theme }) => {
    var _a, _b, _c;
    if ((_b = (_a = theme.automated) === null || _a === void 0 ? void 0 : _a.styles) === null || _b === void 0 ? void 0 : _b.colorPrimary) {
        return tinycolor((_c = theme.automated) === null || _c === void 0 ? void 0 : _c.styles.colorPrimary).setAlpha(0.4).toString();
    }
    return 'var(--text-brand)';
};
export const Container = styled.div `
  display: block;
  width: 24px;
  height: 24px;
  position: relative;
`;
export const Input = styled.input `
  clip: rect(1px, 1px, 1px, 1px);
  position: absolute;
`;
export const Radio = styled.div `
  width: 100%;
  height: 100%;
  border-width: 1px;
  border-style: solid;
  border-color: ${getAutomatedStyleProp('inputBorder', 'var(--border-secondary)')};
  border-radius: 50%;
  background-color: ${getAutomatedStyleProp('colorBackground', 'var(--bg-primary)')};
  position: relative;

  &:after {
    display: block;
    content: '';
    width: 10px;
    height: 10px;
    border-radius: 50%;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translateX(-50%) translateY(-50%);
    visibility: hidden;
  }

  label:hover & {
    border-color: ${getAutomatedStyleProp('paleTextColor', 'var(--border-active)')};
  }

  input:focus-visible + & {
    outline: 2px solid ${getOutlineColor};
    outline-offset: 1px;
    transition: 'outline-offset 0s, outline 0s';
  }

  input:active + & {
    border-color: ${getAutomatedStyleProp('paleTextColor', 'var(--border-active)')};

    &:after {
      background: ${getAutomatedStyleProp('colorPrimary', 'var(--border-active)')};
      visibility: visible;
    }
  }

  input:checked + & {
    border-color: ${getAutomatedStyleProp('colorPrimary', 'var(--bg-brand)')};
    background-color: ${getAutomatedStyleProp('colorPrimary', 'var(--bg-brand)')};

    &:after {
      background: ${getAutomatedStyleProp('colorBackground', 'var(--text-on-brand)')};

      visibility: visible;
    }
  }

  input:disabled + & {
    cursor: not-allowed;
    background-color: var(--bg-tertiary);
    border-color: var(--border-secondary);
  }

  input:checked:disabled + & {
    background-color: var(--bg-tertiary);
    border-color: var(--border-secondary);

    &:after {
      background: var(--border-primary);
    }
  }
`;
//# sourceMappingURL=Radio.styled.js.map